import { queryAllByAttribute, queryByAttribute } from '@testing-library/react';
import { IPartnerEnrollmentStatus, IPartnerIntegration } from '@lib/types';
import { NewJoinSessionData, PartnerEnrollments } from '../application/models/NewJoinSessionData';

export const getAllByQuid = queryAllByAttribute.bind(null, 'data-quid');
export const getAllById = queryAllByAttribute.bind(null, 'id');
export const getAllByHref = queryAllByAttribute.bind(null, 'href');

export const getByQuid = queryByAttribute.bind(null, 'data-quid');
export const getById = queryByAttribute.bind(null, 'id');
export const getByClass = queryByAttribute.bind(null, 'class');
export const getAllByClass = queryAllByAttribute.bind(null, 'class');

export const getByAria = queryByAttribute.bind(null, 'aria-label');

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const waitForDomChange = (target = document.body): Promise<void> => {
  return new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      observer.disconnect();
      resolve();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });
  });
};

export const injectPartnerIntegration =
  (cache: NewJoinSessionData) =>
  (
    availableOffers: IPartnerIntegration[],
    partnerEnrollment?: PartnerEnrollments,
    partnerStatuses?: IPartnerEnrollmentStatus[],
    completedRegistration?: boolean,
    completedPartnerEnrollment?: boolean
  ) => {
    // @ts-ignore
    delete window.localStorage;
    // @ts-ignore
    window.localStorage = Object.assign(
      {
        setItem: jest.fn(),
        getItem: () =>
          JSON.stringify({
            ...cache,
            completedRegistration: !!completedRegistration,
            completedPartnerEnrollment: !!completedPartnerEnrollment,
            confirmationData: {
              ...cache.confirmationData,
              partnerIntegrations: availableOffers,
            },
            partnerOffers: {
              availableOffers: availableOffers,
              enrollmentStatus: null,
              enrollmentEmail: null,
              partnerStatuses: partnerStatuses,
            },
            formData: {
              ...cache.formData,
              partnerEnrollments: partnerEnrollment,
            },
          }),
      },
      {}
    );
  };
